export default {
  "ProfileAvatar": "_ProfileAvatar_4xgz3_1",
  "FallbackInitial": "_FallbackInitial_4xgz3_36",
  "ProfileImage": "_ProfileImage_4xgz3_41"
};import "ni:sha-256;3gDkWilw0LVsQpI-Ay9i8m9vFq2XzkUMqwkyhHmpgcw";